$(document).ready(function() {
// Video carousel
  var videoOwl = $('.video-owl');
  videoOwl.owlCarousel({
    margin: 20,
    items: 3,
    nav: true,
    loop: true,
    autoplay: false,
    dots: false,
    mouseDrag: true,
    touchDrag: true,
    responsive: {
      0: {
        items: 2,
        margin: 30
      },
      768: {
        items: 2,
        margin: 30
      },
      992: {
        items: 5
      }
    }
  });

  function stopAllVideos() {
    $('.video-owl video').each(function() {
      this.pause();
      this.currentTime = 0;
    });
  }

  videoOwl.on('translate.owl.carousel', function() {
    stopAllVideos();
  });

  $('.video-owl .owl-prev, .video-owl .owl-next').on('click', function() {
    stopAllVideos();
  });

  $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function() {
    stopAllVideos();
  });

  // sticky with offset
  $(window).on("load", function() {
    var topDist2 = $(".scrl-btns2").offset().top;

    $(window).scroll(function() {
      var scroll2 = $(this).scrollTop();

      if (scroll2 >= topDist2) {
        $(".scrl-btns").addClass("scrl-sticky");
      } else {
        $(".scrl-btns").removeClass("scrl-sticky");
      }
    });
  });
});